import React from 'react';
import classNames from 'classnames';
import { CommonProps } from 'src/components/helpers/props';

import './index.scss';

export interface IProps extends CommonProps {
  classes?: string;
  form?: boolean;
}

const ContentBody: React.FC<IProps> = ({ classes, children, form, ...props }) => {
  return (
    <div
      className={classNames(
        'content-body-root',
        {
          'form-page-root': form === true,
        },
        classes
      )}
      {...props}
    >
      {children}
    </div>
  );
};

export default ContentBody;
